import React from "react";
import d3 from "d3";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as PageActions from "actions/PageActions";

import { introJs } from "intro.js";

import { Header, LeftNav, PageContainer, ContentSection, RightPane, SectionHead, Pages } from "../components";


class ChartXLBasePage extends React.Component {
	constructor(props) {
		super(props);
		this.handleWindowResize = this.handleWindowResize.bind(this);
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.handleWindowResize);
	}
	componentDidMount() {
		window.addEventListener("resize", this.handleWindowResize);

		var { handleDemoComplete, demo : { complete: demoComplete } } = this.props;
		var finish = () => {
			handleDemoComplete();
		};
		// var demoComplete = Cookies.get("demoComplete") === "Y";

		// console.log(`value of cookie demoComplete is ${Cookies.get("demoComplete")}`)
		if (!demoComplete) {
			setTimeout(() => {
				introJs().setOptions({
						disableInteraction: true,
						showStepNumbers: false,
						exitOnOverlayClick: false,
						// tooltipPosition: "auto",
					}).start()
					.oncomplete(finish)
					.onexit(finish);
			}, 400);
		}
	}
	handleWindowResize() {
		this.props.windowResize();
	}
	render() {

		let { moduleToggle, dispatch, route, chartPageProps } = this.props;

		let pages = Pages.filter(each => each.route === route);
		if (pages.length === 0) {
			route = "/404";
			pages = Pages.filter(each => each.route === route);
		}
		const Page = pages[0].page;

		const { SectionHead, SectionContent, Actions } = Page;
		var header = moduleToggle.showHeader ? <Header /> : null;
		var leftNav = moduleToggle.showLeftNav ? <LeftNav /> : null;

		return (
			<div>
				{header}
				<PageContainer hideLeftNav={!moduleToggle.showLeftNav} hideHeader={!moduleToggle.showHeader}>
					{leftNav}
					<ContentSection rightPane={moduleToggle.showRightPane}>
						<div className="content">
							<SectionContent pageProps={chartPageProps} />
							<SectionHead rightPane={moduleToggle.showRightPane} />
						</div>
						<RightPane show={moduleToggle.showRightPane}/>
					</ContentSection>
				</PageContainer>
			</div>
		);
	}
}

/*
				<div className="modal-backdrop fade in" />
				<div style={{ position: "fixed", top: 0, right: 10, height: 40, width: 190, zIndex: 1999,
					backgroundColor: "rgba(255, 255, 255, 0.9)" }}>
				</div>
*/

function mapStateToProps(state) {
	return {
		moduleToggle: state.moduleToggler,
		route: state.routeTo,
		chartPageProps: state.chartPage,
		demo: state.demo,
	};
}

function mapDispatchToProps(dispatch) {
	return { 
		windowResize: bindActionCreators(PageActions.windowResize, dispatch),
		handleDemoComplete: bindActionCreators(PageActions.handleDemoComplete, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ChartXLBasePage);



/** WEBPACK FOOTER **
 ** ./src/scripts/containers/ChartXLBasePage.js
 **/